import { useState, useEffect } from 'react';
import { apiClient } from '@/services/base';
import SearchApiService from '@/api/search';
import { SearchResult } from '@/api/search/types';

const searchApiService = new SearchApiService(apiClient);

const useSearch = (debounceValue: string) => {
  const [searchData, setSearchData] = useState<Array<SearchResult> | undefined>(undefined);

  useEffect(() => {
    const fetchSearchResults = async () => {
      if (debounceValue.length > 2) {
        try {
          const res = await searchApiService.getSearchResults(debounceValue);
          setSearchData(res.data);
        } catch (error) {
          console.error('Failed to fetch search results:', error);
        }
      }
    };

    fetchSearchResults();
  }, [debounceValue]);

  return { searchData };
};

export default useSearch;
